import React, { useEffect } from 'react';
import { IdentityFinishMessageByVideo } from 'routes/formsView/IdentityVerificationViews/IdentityFinishMessageByVideo';
import { VIDEO_SELFIE } from 'constants/identityMethod';
import { Header } from 'components/header/header';

export const SuccessView = ({ investmentType, handleFinishIdentity, name, onLoad }) => {
    useEffect(onLoad, []);

    return (
        <>
            <Header />
            <IdentityFinishMessageByVideo
                onHandleFinishIdentity={handleFinishIdentity}
                video={VIDEO_SELFIE}
                investmentType={investmentType}
                userProfileName={name}
            />
        </>
    );
};
